import {
  OPEN_SERVICES_TOTAL_GET,
  SERVICES_BY_TYPE_AND_PLACE_GET,
  AVERAGE_SERVICE_TIME_GET
} from "./mutation-types";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { errorMessage, showMessage } from "@/services/MessageService";
import { firestore } from "@/config/firebase";
export default {
  async getOpenServicesTotal({ commit }, { branch }) {
    loaderStart();
    try {
      const products = (await firestore("dynamic-board")
        .doc("products")
        .get()).data();
      if (branch) {
        commit(OPEN_SERVICES_TOTAL_GET, {
          service: products.productsTotals[branch].fieldService,
          counter: products.productsTotals[branch].inService
        });
      } else {
        commit(OPEN_SERVICES_TOTAL_GET, {
          service: products.productsFieldInService,
          counter: products.productsInService
        });
      }
    } catch (error) {
      console.warn(error);

      errorMessage(
        "Ha ocurrido un error inesperado al obtener datos de servicios abiertos"
      );
    } finally {
      loaderDone();
    }
  },
  async getServicesByTypeAndPlace({ commit }, { type, place, branch }) {
    try {
      const lastUpdatedServiceDate = (await firestore("dynamic-board")
        .doc("services")
        .collection("items")
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get()).docs[0].data().lastUpdate;
      if (branch) {
        const branchMap = (await firestore("dynamic-board")
          .doc("commun")
          .get()).data().orderToProductVenues;
        const services = await firestore("dynamic-board")
          .doc("services")
          .collection("items")
          .where("place", "==", place)
          .where("type", "==", type)
          .where("venueId", "==", branchMap[branch])
          .where("lastUpdate", "==", lastUpdatedServiceDate);

        services.onSnapshot(serviceItems => {
          let higher = 0;
          let lower = 0;
          let higherOneDay = 0;
          let lowerOneDay = 0;
          serviceItems.forEach(service => {
            if (service.data().days > 1) {
              higherOneDay++;
            } else if (service.data().days <= 1) {
              lowerOneDay++;
            }
            if (service.data().days > 20) {
              higher = higher + 1;
            } else if (service.data().days <= 20) {
              lower = lower + 1;
            }
          });
          commit(SERVICES_BY_TYPE_AND_PLACE_GET, {
            type: type,
            place: place,
            counter: [serviceItems.docs.length],
            higher: higher,
            lower: lower,
            lessThanADay: lowerOneDay,
            moreThanADay: higherOneDay
          });
        });
      } else {
        const services = await firestore("dynamic-board")
          .doc("services")
          .collection("items")
          .where("place", "==", place)
          .where("type", "==", type)
          .where("lastUpdate", "==", lastUpdatedServiceDate);
        services.onSnapshot(serviceItems => {
          let higher = 0;
          let lower = 0;
          let higherOneDay = 0;
          let lowerOneDay = 0;
          serviceItems.forEach(service => {
            if (service.data().days > 1) {
              higherOneDay++;
            } else if (service.data().days <= 1) {
              lowerOneDay++;
            }
            if (service.data().days > 20) {
              higher = higher + 1;
            } else if (service.data().days <= 20) {
              lower = lower + 1;
            }
          });
          commit(SERVICES_BY_TYPE_AND_PLACE_GET, {
            type: type,
            place: place,
            counter: [serviceItems.docs.length],
            higher: higher,
            lower: lower,
            lessThanADay: lowerOneDay,
            moreThanADay: higherOneDay
          });
        });
      }
    } catch (error) {
      errorMessage(
        "Ha ocurrido un error inesperado al consultar los datos de servicios"
      );
    }
  },
  async getAverageServiceTime({ commit }, { place, type, branch }) {
    try {
      const servicesQuerySnapshot = await firestore("dynamic-board")
        .doc("services")
        .collection("items")
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get();
      if (!servicesQuerySnapshot.empty) {
        const lastUpdatedServiceDate = servicesQuerySnapshot?.docs[0]?.data()
          ?.lastUpdate;

        const servicesDoc = await firestore("dynamic-board")
          .doc("services")
          .get();

        if (branch) {
          const branchMap = (await firestore("dynamic-board")
            .doc("commun")
            .get()).data().orderToProductVenues;
          const servicesQuery = await firestore("dynamic-board")
            .doc("services")
            .collection("items")
            .where("place", "==", place)
            .where("type", "==", type)
            .where("venueId", "==", branchMap[branch])
            .where("lastUpdate", "==", lastUpdatedServiceDate);
          servicesQuery.onSnapshot(async query => {
            let average = 0;
            let sum = 0;
            let closedOders = 0;
            if (!query.empty) {
              await query.forEach(service => {
                closedOders = servicesDoc.data().closedOrders[
                  branchMap[branch]
                ];
                sum = sum + service.data().serviceHours;
              });
              average = sum / closedOders;
              commit(AVERAGE_SERVICE_TIME_GET, {
                average: parseFloat(average.toFixed(1)),
                place: place,
                type: type
              });
            } else {
              commit(AVERAGE_SERVICE_TIME_GET, {
                average: 0,
                place: place,
                type: type
              });
            }
          });
        } else {
          const servicesQuery = await firestore("dynamic-board")
            .doc("services")
            .collection("items")
            .where("place", "==", place)
            .where("type", "==", type)
            .where("lastUpdate", "==", lastUpdatedServiceDate);
          servicesQuery.onSnapshot(async query => {
            let average = 0;
            let sum = 0;
            let closedOders = 0;
            if (!query.empty) {
              await query.forEach(service => {
                closedOders = servicesDoc.data().totalClosedOrders;
                sum = sum + service.data().serviceHours;
              });
              average = sum / closedOders;
              commit(AVERAGE_SERVICE_TIME_GET, {
                average: parseFloat(average.toFixed(1)),
                place: place,
                type: type
              });
            } else {
              commit(AVERAGE_SERVICE_TIME_GET, {
                average: 0,
                place: place,
                type: type
              });
            }
          });
        }
      } else {
        showMessage({
          message: "No se han encontrado datos del tiempo promedio",
          color: "orange lighten-1"
        });
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error al conseguir el tiempo promedio");
    }
  }
};
